import API from "../api/manager";
import config from "../api/config";

const generateRTMPLink = (meetingId) => {
  return API({
    method: "GET",
    url: `${config.urls.meeting.generateRTMPLink}/${meetingId}`,
  });
};

const liveTranscriptionSegments = (caseId) => {
  return API({
    method: "GET",
    url: `${config.urls.transcription.liveTranscriptSegments}/${caseId}`,
  });
};

export default {
  generateRTMPLink,
  liveTranscriptionSegments,
};
